import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Destinations } from "../components/Destinations";
import { Wildlife } from "../components/Wildlife";
import { FeaturedTours } from "../components/FeaturedTours";
import { Adventure } from "../components/Adventure";
import { Rentals } from "../components/Rentals";
import { About } from "../components/About";
import { WhyUs } from "../components/WhyUs";
import { Trust } from "../components/Trust";
import { Testimonials } from "../components/Testimonials";
import { Stories } from "../components/Stories";
import { Contact } from "../components/Contact";
import { scrollToId } from "../components/Navbar";

export default function Home() {
  const { state } = useLocation();

  useEffect(() => {
    if (state?.scrollTo) {
      const t = setTimeout(() => scrollToId(state.scrollTo), 350);
      return () => clearTimeout(t);
    }
  }, [state]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Destinations />
      <Wildlife />
      <FeaturedTours />
      <Marquee reverse />
      <Adventure />
      <Rentals />
      <About />
      <WhyUs />
      <Trust />
      <Testimonials />
      <Stories />
      <Contact />
    </main>
  );
}
